import Tooltip from '../Tooltip.jsx';
import TopbarIconButton from './TopbarIconButton.jsx';

const TopbarActionButtons = ({ actions = [], topbarVariant = 'default', tooltips = {} }) => (
  <div className="flex items-center gap-2">
    {actions.map((action) => {
      const resolvedVariant =
        action.variant === 'assistant' && topbarVariant === 'primary'
          ? 'assistantPrimary'
          : action.variant || 'ghost';
      const tooltipContent = tooltips[action.id] || action.tooltip;

      if (!tooltipContent) {
        return (
          <TopbarIconButton
            key={action.id}
            icon={action.icon}
            onClick={action.onClick}
            ariaLabel={action.ariaLabel}
            title={action.tooltip}
            variant={resolvedVariant}
            size={action.size || 'default'}
            showBadge={Boolean(action.showBadge)}
          />
        );
      }

      return (
        <Tooltip
          key={action.id}
          content={tooltipContent}
          arrow={false}
          position="bottom"
          align="start"
          triggerClassName="inline-flex w-fit"
        >
          <TopbarIconButton
            icon={action.icon}
            onClick={action.onClick}
            ariaLabel={action.ariaLabel}
            title={undefined}
            variant={resolvedVariant}
            size={action.size || 'default'}
            showBadge={Boolean(action.showBadge)}
          />
        </Tooltip>
      );
    })}
  </div>
);

export default TopbarActionButtons;
